module.exports = __webpack_public_path__ + "img/4.e8cf81de.jpg";